import React from 'react'
import numeral from 'numeral'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

import Link from './../Link'

export default ({ lot, fund, info }) => (
  <div className='Fallback'>
    <div className='Container Container_light'>
      <div className='Fallback__body'>
        <div className='Fallback__sidebar'>
          <div className='Fallback__sidebar-body'>
            <div className='Fallback__sidebar-person'>
              <div className='Fallback__sidebar-img-wrap'>
                <img src={lot.image} alt={lot.title} className='Fallback__sidebar-img' />
                <div className='Fallback__sidebar-overlay' />
              </div>
              <h1 className='Fallback__sidebar-head Head'>
                <FormattedHTMLMessage id='payment_fallback.success' />
              </h1>
              <a href='/' className='Fallback__sidebar-button Button Button_white'>
                <FormattedHTMLMessage id='payment_fallback.home' />
              </a>
            </div>
          </div>
        </div>

        <div className='Fallback__main'>
          <div className='Fallback__main-body'>
            <div className='Fallback__main-section'>
              <span className='Text'>
                <FormattedMessage id='payment_fallback.foundation' />
              </span>
              <Link to={`/funds/${fund._id}`}>
                <h1 className='Fallback__main-fund SubHead'>«{fund.name}»</h1>
              </Link>
              {/* <img src={fund.logo} alt={fund.name} className='Fallback__main-logo' /> */}
            </div>
            <div className='Fallback__main-section'>
              <span className='Text'>
                <FormattedMessage id='payment_fallback.sum' />
              </span>
              <span className='Fallback__main-total Head'>{info.value ? numeral(info.value).format('0,0') : 0} {info.currency.symbol}</span>
            </div>
            <a href='/' className='Fallback__main-button Button Button_black'>
              <FormattedMessage id='payment_fallback.home' />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Payment/Fallback.jsx